import { fields, createSchema, validate as _validate } from '..';

const { password } = fields;

const schema = createSchema({
  password,
});

const validate = (data) => {
  return _validate(schema, data);
};

export default validate;
